import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography
} from '@mui/material';

import TablePaginationActions from '../../../../../components/utils/TablePaginationActions';
import useTablePaginationInit from '../../../../../components/hooks/useTablePaginationInit';
import Copyable from '../../../../../components/utils/Copyable';
import TopBar from '../../../../../components/utils/TopBar';
import NA from '../../../../../components/utils/NA';

import {
  GetPivotMastersBIZcoreTD
} from '../../../../../redux/actions/business/core/pivotMastersActions';

const PivotMastersPage = () => {
  const dispatch = useDispatch();
  const state = useSelector(state => state["business.core.tradeDefence"]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");

  const [mastersList, setMastersList] = useState([]);
  const [mastersTotal, setMastersTotal] = useState(0);

  const [
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage
  ] = useTablePaginationInit();

  const tableHeadingsList = [
    { label: "Id", sort: "id" },
    { label: "Entry id", sort: "ref_entry_id" },
    { label: "Total pivot rows", sort: "total_pivot_rows" },
    { label: "Created at", sort: "created_at" },
  ];

  const handleSort = (value) => {
    setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    setSort(value);
  };

  useEffect(() => {
    handleGetMasters();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage, search, sort, sortDirection]);

  useEffect(() => {
    try {
      setMastersList(state.pivotMastersList.records || []);
      setMastersTotal(state.pivotMastersList.total || 0);
    } catch (err) {}
  }, [state]);

  async function handleGetMasters(customLoading) {
    let query = "";
    if (search) query += `&search=${search}`;
    if (sort) query += `&ordering=${sortDirection === "asc" ? '' : '-'}${sort}`;
    dispatch(GetPivotMastersBIZcoreTD(page + 1, rowsPerPage, query, true, customLoading ? customLoading : setLoading));
  };

  return (
    <Box>

      <TopBar
        title={"Pivot masters"}
        search={search}
        onSearchChange={(e) => setSearch(e.target.value)}
      />

      {
        loading
        ?
        <Box height={"300px"} className="flexCenterCenterRow">
          <CircularProgress />
        </Box>
        :
          mastersList.length === 0
          ?
          <Box height={"300px"} className="flexCenterCenterRow">
            <Typography>No pivot master found</Typography>
          </Box>
          :
          <Table className="block">
            <TableHead>
              <TableRow>
                {
                  tableHeadingsList.map((heading, headingIndex) => (
                    <TableCell key={headingIndex}>
                      <TableSortLabel
                        active={sort === heading.sort}
                        direction={sortDirection}
                        onClick={() => handleSort(heading.sort)}
                      >
                        {heading.label}
                      </TableSortLabel>
                    </TableCell>
                  ))
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {
                mastersList.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <Typography variant='caption' color={"grey"}>
                        <Copyable>{row.id || <NA />}</Copyable>
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant='caption' color={"grey"}>
                        <Copyable>{row.ref_entry_id || <NA />}</Copyable>
                      </Typography>
                    </TableCell>
                    <TableCell>{row.total_pivot_rows ?? <NA />}</TableCell>
                    <TableCell>
                      <Typography variant='caption' color={"grey"}>{row.created_at || <NA />}</Typography>
                    </TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  sx={{ borderBottom: 0 }}
                  rowsPerPageOptions={[5, 10, 25, 50, 100]}
                  colSpan={4}
                  count={mastersTotal}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: { 'aria-label': 'rows per page' },
                    native: true
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
      }

    </Box>
  );
};

export default PivotMastersPage;
